import _extends from "@babel/runtime/helpers/extends";
import _typeof from "@babel/runtime/helpers/typeof";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import './Style.scss';
var ColorLabelContainer = /*#__PURE__*/function (_Component) {
  function ColorLabelContainer(props) {
    var _this;
    _classCallCheck(this, ColorLabelContainer);
    _this = _callSuper(this, ColorLabelContainer, [props]);
    _defineProperty(_this, "setContainer", function (element) {
      _this.container = element;
    });
    _defineProperty(_this, "onResize", function () {
      if (_this.container == null) {
        return false;
      }
      var containerWidth = _this.container.clientWidth;
      if (_this.contentWidth == null) {
        return false;
      }
      if (containerWidth < _this.contentWidth) {
        if (_this.state.collapse == false) {
          _this.setState({
            collapse: true
          });
        }
      } else {
        if (_this.state.collapse == true) {
          _this.setState({
            collapse: false
          });
        }
      }
    });
    _defineProperty(_this, "calculateCollapse", function () {
      // Issue where the container is no longer rendered on screen but the calculateCollapse still runs
      // and refs['container'] == undefined
      if (_this.container != null) {
        var contentWidth = 0;
        var dots = _toConsumableArray(_this.container.querySelectorAll('.dot'));
        dots.forEach(function (dot) {
          if (dots.length > 1) {
            // Add extra 10 px for margin
            contentWidth = contentWidth + dot.clientWidth + 25;
          } else {
            contentWidth = contentWidth + dot.clientWidth;
          }
        });
        _this.contentWidth = contentWidth;
      }
    });
    _this.state = {
      collapse: false
    };
    _this.container = null;
    _this.contentWidth = null;
    return _this;
  }
  _inherits(ColorLabelContainer, _Component);
  return _createClass(ColorLabelContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.calculateCollapse();
      this.onResize();
      window.addEventListener('resize', this.onResize);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevChildren = [];
      var currentChildren = [];
      if (prevProps != null && prevProps.children != null && _typeof(prevProps.children) == 'object') {
        prevChildren = prevProps.children;
      }
      if (this.props != null && this.props.children != null && _typeof(this.props.children) == 'object') {
        currentChildren = prevProps.children;
      }
      if (prevChildren.length != currentChildren.length) {
        this.calculateCollapse();
        this.onResize();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.onResize);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var collapse = this.state.collapse;
      var props = Object.assign({}, this.props);
      delete props.collapse;
      delete props.inline;
      return /*#__PURE__*/React.createElement("div", _extends({
        ref: this.setContainer,
        className: 'dots-container' + (this.props.collapse || collapse ? ' collapse' : '') + (!this.props.collapse && !collapse ? ' show-content' : '') + (this.props.inline ? ' inline' : '')
      }, props), children, !this.props.inline ? /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      }) : null);
    }
  }]);
}(Component);
export default ColorLabelContainer;